import Todo from "./todo/todo.js";
function App() {
  return (
    <>
      <Todo />
    </>
  );
}

export default App;
